<template>
  <transition
    enter-active-class="transition duration-100 ease-out"
    enter-class="transform scale-95 opacity-0"
    enter-to-class="transform scale-100 opacity-100"
    leave-active-class="transition duration-75 ease-in"
    leave-class="transform scale-100 opacity-100"
    leave-to-class="transform scale-95 opacity-0"
  >
    <div
      v-if="isOpen"
      class="text-secondary mt-2 bg-white border divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
      :class="[customClass, setPosition, setAbsolute, {'dark:bg-darkblue-900 dark:divide-gray-500 dark:border-darkblue-600': autoDarkMode}, {'border-primary-300': !autoDarkMode}]"
      @click="setAutoClose"
    >
      <slot />
      <util-keys @keyup.esc="escDropdown" />
    </div>
  </transition>
</template>

<script>
import UtilKeys from '@/components/utilities/UtilKeys'
export default {
  name: 'dropwdown-base',
  components: {
    UtilKeys
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: [Array, String, Object],
      default: 'w-56'
    },
    position: {
      type: String,
      default: 'top-left'
    },
    autoClose: {
      type: Boolean,
      default: false
    },
    absolute: {
      type: Boolean,
      default: true
    },
    autoDarkMode: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    setPosition: function () {
      return {
        'origin-bottom-right right-0': this.position === 'bottom-right',
        'origin-top-left left-0': this.position === 'top-left',
        'origin-top-right right-0': this.position === 'top-right',
        'origin-center left-0': this.position === 'center'
      }
    },
    setAbsolute: function () {
      return {
        absolute: this.absolute === true,
        '': this.absolute === false
      }
    }
  },
  methods: {
    setAutoClose: function () {
      if (this.autoClose) this.escDropdown()
    },
    escDropdown: function () {
      this.$emit('toggle')
    }
  }
}
</script>

<style lang="scss" scoped></style>
